import CloseIcon from '@mui/icons-material/Close';
import FolderIcon from '@mui/icons-material/Folder';
import { Box, Button, IconButton, Stack, TextField } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles(() => ({
    container: {
        backgroundColor: '#f0fdfa',
        border: '2px solid #99f6e4',
        borderRadius: '8px',
        padding: '12px',
        marginBottom: '8px',
    },
    folderIcon: {
        color: '#14b8a6',
    },
    inputField: {
        width: '100%',
        margin: 0,
        "& .MuiOutlinedInput-root": {
            height: 40,
            borderRadius: 8,
            background: '#fff',
            "& > input": {
                fontSize: 16,
            },
            '& fieldset': {
                borderColor: '#5eead4 !important',
            },
            '&:hover fieldset': {
                borderColor: '#14b8a6 !important',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#14b8a6 !important',
            },
        },
    },
    addButton: {
        backgroundColor: '#14b8a6',
        color: '#ffffff',
        textTransform: 'none',
        fontWeight: 500,
        height: 35,
        borderRadius: 8,
        '&:hover': {
            backgroundColor: '#0d9488',
        },
        '&:disabled': {
            backgroundColor: '#d1d5db',
        },
    },
    cancelButton: {
        color: '#4b5563',
        padding: '6px',
        '&:hover': {
            backgroundColor: '#e5e7eb',
        },
    },
}));

interface FolderInputRowProps {
    value: string;
    onChange: (value: string) => void;
    onSubmit: () => void;
    onCancel: () => void;
    placeholder?: string;
    indentLevel?: number;
}

export const FolderInputRow: React.FC<FolderInputRowProps> = ({
    value,
    onChange,
    onSubmit,
    onCancel,
    placeholder = 'Enter folder name...',
    indentLevel = 0,
}) => {
    const classes = useStyles();
    const indent = indentLevel * 24;

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            onSubmit();
        } else if (e.key === 'Escape') {
            onCancel();
        }
    };

    return (
        <Box className={classes.container} style={{ marginLeft: `${indent}px` }}>
            <Stack direction="row" alignItems="center" spacing={1}>
                <FolderIcon className={classes.folderIcon} fontSize="small" />
                <TextField
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder={placeholder}
                    autoFocus
                    size="small"
                    className={classes.inputField}
                    sx={{ flex: 1 }}
                />
                <Button
                    onClick={onSubmit}
                    disabled={!value.trim()}
                    className={classes.addButton}
                    size="small"
                >
                    Add
                </Button>
                <IconButton onClick={onCancel} className={classes.cancelButton} size="small">
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Stack>
        </Box>
    );
};
